export default __webpack_public_path__ + "static/media/residential.26674987.jpg";